<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template><div><div v-if="admin_all_users">
	<div class="py-4 d-flex align-center">
		<h3 class="mr-3">ALL Users:</h3>
		<k-text-field
			v-model="search"
			prepend-inner-icon="fa fa-search" prepend-decorative clearable clear-icon="fa fa-times-circle"
			aria-label="Search all users"
			@keyup="search_field_keyup"
			label="Search" single-line hide-details outlined dense background-color="#fff" style="flex:0 1 350px"
		/>
		<k-btn v-if="search" small class="ml-2 k-tight-btn" color="#333" dark @click="search_db">
			<k-icon small class="mr-2">fas fa-search</k-icon> Database Search
		</k-btn>
		<k-btn v-if="!search" small class="ml-2 k-tight-btn" color="#333" dark @click="search_db">
			<k-icon small class="mr-2">fas fa-redo</k-icon> Refresh Data
		</k-btn>
		<k-spacer/>
		<i style="font-size:13px; line-height:15px">Dates are shown in your local time</i>
		<k-spacer/>
		<i class="mr-3">{{$store.state.admin_all_user_count}} <span style="font-size:0.9em">total users</span></i>
		<k-btn small v-show="page_number>1||admin_all_users.length==0" color="#333" class="mr-1 k-tight-btn" dark @click="load_previous_page"><k-icon small class="mr-2">fas fa-arrow-left</k-icon>Prev Page</k-btn>
		<k-btn v-show="admin_all_users.length>0" small color="#333" class="k-tight-btn" dark @click="load_next_page">Next Page<k-icon small class="ml-2">fas fa-arrow-right</k-icon></k-btn>
	</div>

	<k-data-table
		class="k-admin-users-table"
		:headers="headers"
		:items="rows"
		:sort-by.sync="order_by"
		:sort-desc.sync="desc_or_asc"
		@update:sort-by="sort_by_changed"
		@update:sort-desc="sort_by_changed"
		:must-sort="true"
		:custom-filter="table_search_filter"
		:search="search"
		:footer-props="footer_options"
		:items-per-page="-1"
		hide-default-footer
		light
	>
		<template v-slot:item="{ item }">
			<tr>
				<td>
					<k-btn icon x-small color="red darken-3" class="mr-2" :accessible-label="`Delete user ${item.display_name}`" @click="delete_user(item)"><k-icon small>fas fa-trash-alt</k-icon></k-btn>
					{{item.user_id}}
				</td>
				<td>{{item.display_name}}</td>
				<td>{{item.email}}</td>
				<td>{{item.created_at_display}}</td>
				<td>{{item.last_login_display}}</td>
				<td class="text-center">{{item.login_count}}</td>
			</tr>
		</template>
	</k-data-table>
</div></div></template>

<script>
import { mapState } from 'vuex'

export default {
	components: {  },
	data() { return {
		order_by: ['last_login'],
		desc_or_asc: [true],
		// desc_or_asc: 'desc',
		page_number: 1,
		search: '',

		footer_options: {
			itemsPerPageOptions: [-1],
		},
	}},

	computed: {
		...mapState(['user_info', 'all_courses_loaded', 'all_courses', 'site_config', 'todo_user_group_divisions', 'todo_user_group_schools', 'admin_all_users']),

		headers() {
			let arr = [
				{ text: 'User ID', align: 'center', sortable: false, value: 'user_id' },
				{ text: 'Name', align: 'left', sortable: true, value: 'last_name' },
				{ text: 'Email', align: 'left', sortable: true, value: 'email' },
				{ text: 'Created At', align: 'left', sortable: true, value: 'created_at' },
				{ text: 'Last Login', align: 'left', sortable: true, value: 'last_login' },
				{ text: 'Login Ct', align: 'center', sortable: true, value: 'login_count' },
			]
			return arr
		},

		rows() {
			if (empty(this.admin_all_users)) return []

			let arr = []

			for (let u of this.admin_all_users) {
				let o = object_copy(u)
				o.display_name = `${o.first_name} ${o.last_name}`
				o.user_lc = `${o.display_name} ${o.email}`.toLowerCase()
				// PW 8/19/2026: convert dates to local time; note that Inspire prod, the one server not on GMT, needs to have convert_to_local_date_offset_adjustment set to 300 to compensate)
				if (empty(o.created_at)) {
					console.log('empty created_at', o)
					o.created_at_display = ''
				} else {
					o.created_at_display = date.format(U.convert_to_local_date(o.created_at), 'MM/DD/YY  h:mm A')
				}
				if (empty(o.last_login)) {
					console.log('empty last_login', o)
					o.last_login_display = ''
				} else {
					o.last_login_display = date.format(U.convert_to_local_date(o.last_login), 'MM/DD/YY  h:mm A')
				}

				arr.push(o)
			}

			return arr
		},
	},

	created() {
		// DEBUG
		vapp.admin_users_all_component = this
		console.warn('AdminUsersAll created')
		if (empty(this.admin_all_users)) {
			this.load_all_users_list()
		}
	},
	
	methods: {
		load_all_users_list(flag) {
			let payload = {
				user_id: this.user_info.user_id,
				order_by: this.order_by[0],
				desc_or_asc: (this.desc_or_asc[0]) ? 'desc' : 'asc',
				page_number: this.page_number,
			}
			this.search = this.search.trim()
			if (!empty(this.search)) payload.search = this.search

			U.loading_start()
			U.ajax('admin_get_user_data', payload, result=>{
				U.loading_stop()
				if (result.status != 'ok') {
					console.error('Error in admin ajax call'); vapp.ping(); return;
				}

				this.$store.commit('set', ['admin_all_user_count', result.user_count])
				this.$store.commit('set', ['admin_all_users', result.user_data])
				// format for each all_user: { user_id, first_name, last_name, email, created_at, last_login, login_count }
			})
		},

		load_next_page() {
			++this.page_number
			this.load_all_users_list()
		},

		load_previous_page() {
			--this.page_number
			this.load_all_users_list()
		},

		sort_by_changed() {
			// establish the debounce fn if necessary
			if (empty(this.fn_debounced)) {
				this.fn_debounced = U.debounce(x => {
					// console.warn(object_copy(this.order_by), object_copy(this.desc_or_asc))
					this.page_number = 1
					this.load_all_users_list()
				}, 10)
			}
			// call the debounce fn
			this.fn_debounced()
		},

		search_field_keyup(evt) {
			if (evt.key == 'Enter' || evt.keyCode == 13) {
				this.search_db()
			}
		},

		search_db() {
			this.page_number = 1
			this.load_all_users_list('search')
		},

		table_search_filter(value, search, item) {
			// value is the value of the column (we can ignore this); search is the search string (could be empty)
			// RETURN FALSE TO HIDE THE ITEM

			// if search is empty, always return true, so the row will SHOW
			if (empty(search)) return true

			search = search.toLowerCase()
			let re = new RegExp(search, 'i')

			// check user name
			if (item.user_lc.search(re) > -1) return true

			// if we get to here return false
			return false
		},

		delete_user(user_data) {
			this.$confirm({
				title: 'Are you sure?',
				text: `Are you sure you want to delete user <b>${user_data.first_name} ${user_data.last_name} (${user_data.email})</b>? THIS CANNOT BE UNDONE!`,
				acceptText: 'Delete User',
				acceptColor: 'red darken-3',
				acceptIcon: 'fas fa-trash-alt',
			}).then(y => {
				let payload = {
					user_id: this.user_info.user_id,
					user_id_to_delete: user_data.user_id
				}
				U.loading_start()
				U.ajax('admin_delete_user', payload, result=>{
					U.loading_stop()
					this.load_all_users_list()
				})

			}).catch(n=>{console.log(n)}).finally(f=>{})
		},
	}
}
</script>

<style lang="scss">
</style>
